// extracted by extract-css-chunks-webpack-plugin
module.exports = {"navigation":"_1sWF3D"};